import React, { useContext, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { Alert, Button, Spacer, Dropdown, Text, ThirdTitle, Toggle } from "@dspworkplace/ui";
import { Divider, Label, Status } from "../../../../components/UI";
import { RouteAssistTM } from "./index";
import { AccessCheck, IsGranted } from "../../../../security";

export default function StationOptions({ settings, station }) {
    const { register, watch, reset } = useFormContext();

    const generateTimeOptions = (max) => 
        Array.from({ length: max }, (_, i) => {
          const value = i.toString().padStart(2, '0');
          return { name: value, value };
        });

    const optionHours = generateTimeOptions(24);
    const optionMinutes = generateTimeOptions(60);

    return (
        <Spacer top={10} bottom={5} style={{ position: "relative" }}>
            <input type="hidden" ref={register} name={`id`} defaultValue={settings?.id} />

            <input type="hidden" ref={register} name={`station`} defaultValue={station?.id} />

            {!station ? null : (
                <Spacer bottom={10}>
                    <Toggle
                        ref={register}
                        name={`enabled`}
                        singleText={
                            <>
                                Customize <RouteAssistTM /> for this station
                            </>
                        }
                        on={settings?.enabled}
                    />
                </Spacer>
            )}

            <div
                style={{
                    opacity: !station || watch("enabled") || settings?.enabled ? 1 : 0.5,
                    pointerEvents: !station || watch("enabled") || settings?.enabled ? "auto" : "none",
                }}
            >
                <Spacer >
                    <label
                        style={{
                            fontSize: "16px",
                            fontWeight: "normal",
                            fontFamily: "Circe-Rounded",
                            display: "block",
                            paddingBottom: "2px",
                            color: "#707070",
                        }}
                    >
                        Rest Time Threshold
                    </label>
                    <Dropdown
                        name="restTimeThresholdHour"
                        label="Hour"
                        ref={register}
                        placeholder="Hour"
                        options={optionHours}
                        style={{ marginRight: "5px", fontSize: "12px" }}
                        size="extraSmall"
                        valid={"true"}
                        defaultValue={(settings?.restTimeThreshold) ? settings?.restTimeThreshold.split(":")[0] : "10"}
                        // defaultValue={"10"}
                        visibleOptionsQty={8}
                    />
                    <Dropdown
                        name="restTimeThresholdMinute"
                        ref={register}
                        label="Minute"
                        placeholder="Minute"
                        options={optionMinutes}
                        style={{}}
                        size="extraSmall"
                        valid={"true"}
                        // defaultValue={"00"}
                        defaultValue={(settings?.restTimeThreshold) ? settings?.restTimeThreshold.split(":")[1] : "00"}
                        visibleOptionsQty={8}
                    />
                    <Spacer bottom={5} />
                </Spacer>

                <Spacer top={2}>
                    <label
                        style={{
                            fontSize: "16px",
                            fontWeight: "normal",
                            fontFamily: "Circe-Rounded",
                            display: "block",
                            paddingBottom: "2px",
                            color: "#707070",
                        }}
                    >
                        Send report at (station local time)
                    </label>
                    <Dropdown
                        name="sendReportAtHour"
                        label="Hour"
                        ref={register}
                        placeholder="Hour"
                        options={optionHours}
                        style={{ marginRight: "5px", fontSize: "12px" }}
                        size="extraSmall"
                        valid={"true"}
                        defaultValue={(settings?.sendReportAt) ? settings?.sendReportAt.split(":")[0] : "01"}
                        // defaultValue={"01"}
                    />
                    <Dropdown
                        name="sendReportAtMinute"
                        ref={register}
                        label="Minute"
                        placeholder="Minute"
                        options={optionMinutes}
                        style={{}}
                        size="extraSmall"
                        valid={"true"}
                        defaultValue={(settings?.sendReportAt) ? settings?.sendReportAt.split(":")[1] : "30"}
                        // defaultValue={"30"}
                    />
                    <Spacer bottom={5} />
                </Spacer>

                <Divider top={5} bottom={5} />
            </div>
            <IsGranted feature={AccessCheck.features.SETTINGS} ops={[AccessCheck.OPS.U]}>
                <Spacer bottom={5} />
                <Button type={"primary"}>Save {station?.code}</Button>
            </IsGranted>
        </Spacer>
    );
}
